module.exports = __webpack_public_path__ + "static/media/wallet.7511b9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SkycoinLanding/images/wallet.jpg
// module id = 1202
// module chunks = 0